import { isDate } from 'date-fns';
import { z } from 'zod';
import { toISO8601 } from '@fortem-monorepo/js-utilities';
import { FILTER_TYPES } from './filters.constants';
const createConfig = (config) => config;
export const filterConfig = {
    [FILTER_TYPES.TEXT]: createConfig({
        schema: z.string().optional(),
        hasValue: (val) => typeof val === 'string' && !!val,
        getClearedValue: () => undefined,
        serialize: (name, val) => [[name, val?.length ? val : null]],
        deserialize: (params, name) => {
            const v = params.get(name);
            return v !== null ? v : undefined;
        },
    }),
    [FILTER_TYPES.NUMBER]: createConfig({
        schema: z.number().optional(),
        hasValue: (val) => typeof val === 'number',
        serialize: (name, val) => [[name, val ? val.toString() : null]],
        deserialize: (params, name) => {
            const v = params.get(name);
            return v != null ? Number(v) : undefined;
        },
    }),
    [FILTER_TYPES.BOOLEAN]: createConfig({
        schema: z.boolean().optional(),
        hasValue: (val) => typeof val === 'boolean',
        serialize: (name, val) => {
            return [[name, typeof val === 'boolean' ? String(val) : null]];
        },
        deserialize: (params, name) => {
            const v = params.get(name);
            const isBoolString = v === 'true' || v === 'false';
            const newVal = isBoolString ? v === 'true' : undefined;
            return newVal;
        },
    }),
    [FILTER_TYPES.DATE]: createConfig({
        schema: z.date().optional(),
        hasValue: (val) => {
            return isDate(val);
        },
        serialize: (name, val) => [[name, isDate(val) ? toISO8601(val) : null]],
        deserialize: (params, name) => {
            const v = params.get(name);
            return v ? (isDate(new Date(v)) ? new Date(v) : undefined) : undefined;
        },
    }),
    [FILTER_TYPES.DATE_RANGE]: createConfig({
        schema: z
            .object({
            st_dt: z.date().optional(),
            ed_dt: z.date().optional(),
        })
            .optional(),
        hasValue: (val) => {
            return isDate(val?.st_dt);
        },
        getClearedValue: () => ({
            st_dt: undefined,
            ed_dt: undefined,
        }),
        serialize: (name, val) => {
            const entries = [];
            entries.push([`${name}_st_dt`, isDate(val?.st_dt) ? toISO8601(val.st_dt) : null]);
            entries.push([`${name}_ed_dt`, isDate(val?.ed_dt) ? toISO8601(val.ed_dt) : null]);
            return entries;
        },
        deserialize: (params, name) => {
            const st_dt = params.get(`${name}_st_dt`) ? new Date(params.get(`${name}_st_dt`)) : undefined;
            const ed_dt = params.get(`${name}_ed_dt`) ? new Date(params.get(`${name}_ed_dt`)) : undefined;
            return st_dt !== undefined || ed_dt !== undefined
                ? {
                    st_dt: params.get(`${name}_st_dt`) ? new Date(params.get(`${name}_st_dt`)) : undefined,
                    ed_dt: params.get(`${name}_ed_dt`) ? new Date(params.get(`${name}_ed_dt`)) : undefined,
                }
                : undefined;
        },
    }),
    [FILTER_TYPES.SELECT]: createConfig({
        schema: z.string().optional(),
        hasValue: () => false,
        getClearedValue: () => '',
        serialize: (name, val) => [[name, val?.length ? val : null]],
        deserialize: (params, name) => {
            return params.get(name) ?? undefined;
        },
    }),
};
